import { SxProps, Container, CircularProgress } from '@mui/material';
import CenterStack from './center-stack';

type Props = {
  loading: boolean;
  children: React.ReactNode;
  sx?: SxProps;
  fitContent?: boolean;
};

export default function LoadingContainer({ loading, children, sx, fitContent }: Props) {
  if (loading) {
    return (
      <CenterStack sx={{ height: '100%', ...sx }}>
        <CircularProgress />
      </CenterStack>
    );
  }

  if (fitContent) {
    return children;
  }

  return <Container>{children}</Container>;
}
